<template>
    <div class="gray-back" style="padding:.2rem 0 8rem 0 ; height:auto !important">
        <div>
            <!-- <img style="width:100%" src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20240403/user-0/20240403/0875a81523a8648a8ffc597127dd18a0.jpg?x-oss-process=style/tb-750" /> -->

        </div>

        <div v-if="row.step==1">

            <div class="huiyi-box-title"   style="margin-top:50px">第一步：请选择您要报名的项目</div>
            
            <div class="baoming-item-box"  >
                <div
                class="baoming-item"
                :key="index"
                v-for="(item, index) in row.group_list"
                :style="getBackground(item,index)"
                @click="onGroupBtn(item, index)"
                >
                {{ item.name }}
                </div>
            </div>

                <!-- <van-cell-group   v-show="groupRow.name" >
                        <van-cell  title="举办时间"  label="2024年4月26日-2024年4月28日" >

                        </van-cell>  
                        <van-cell  title="报名时间"  label="2024年3月26日-2024年4月1日" >

                        </van-cell>  
                        <van-cell  title="活动内容" :label="groupRow.name+'xxxx'" >

                        </van-cell>  
                    </van-cell-group> -->

                    <div   style="height: 100px"></div>

                    <div class="savebtn"   >
                        <van-button
                                color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                                style="width: 3rem"
                                size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">下一步</van-button>
                    </div>

        </div>

        <div v-if="row.step==2"> 
        <van-cell-group  >
            <van-cell is-link v-rblink="{name:'HuiyiApplyList'}" title="我的会议培训报名记录"    >
                <template #default>
                    <!-- <div class="badge" v-if="row.huiyi_count">报名中{{row.huiyi_count}}场</div> -->
                </template>
            </van-cell> 
            <van-cell v-if="false" is-link v-rblink="{name:'ISaiApplyList'}" title="我的赛事报名记录"    >
                <template #default>
                    <!-- <div class="badge" v-if="row.songpei_count">报名中{{row.songpei_count}}场</div> -->
                </template>
            </van-cell> 
        </van-cell-group>

        <div class="huiyi-box-title" v-if="row.check_types.indexOf(1)>-1||row.check_types.indexOf(2)>-1"  style="margin-top:50px">4月10日开始场次</div>

        <div class="huiyi-group-item-box"    > 
            <div
                :key="index"
                class="train-items"
                v-show="row.check_types.indexOf(index+1)>-1 && index<2"
                v-for="(irow, index) in row.doing"
                v-rblink="{
                name: 'HuiyiApplyFormStep1',
                query: { saiqu_id: irow.id },
                }"
            >
                <div
                class="train-items-top items-top1"
                :style="
                    'background-image: linear-gradient(to right, #' +
                    irow.color[0] +
                    ' , #' +
                    irow.color[1] +
                    ');'
                "
                >
                <div>
                    <div class="train-items-top-city">{{ irow.location }}</div>
                    <div class="train-items-top-time">{{ irow.date_str }}</div>
                </div>
                <!--<div class="train-sing-up-btn">报名</div>-->
                </div>
                <div class="train-items-title">{{ irow.name }}</div>
                <div class="flex-between">
                <div class="train-items-time">{{ irow.startdate }}</div>
                <div class="train-items-address">
                    {{ irow.province }}·{{ irow.city }}
                </div>
                </div>
            </div> 
        </div>

 

        <div class="huiyi-box-title"  v-if="row.check_types.indexOf(1)>-1 ||row.check_types.indexOf(2)>-1 "  style="margin-top:50px">4月11日开始场次（如果有人员同时报10号开始的场次，为了避免重复缴纳食宿费，请先报名10号开始的场次，之后再报名11号开始的场次）</div>

        <div class="huiyi-group-item-box"    > 
            <div
                :key="index"
                class="train-items"
                v-show="row.check_types.indexOf(index+1)>-1 && index>=2"
                v-for="(irow, index) in row.doing"
                @click="go2(irow)" 
            >
                <div
                class="train-items-top items-top1"
                :style="
                    'background-image: linear-gradient(to right, #' +
                    irow.color[0] +
                    ' , #' +
                    irow.color[1] +
                    ');'
                "
                >
                <div>
                    <div class="train-items-top-city">{{ irow.location }}</div>
                    <div class="train-items-top-time">{{ irow.date_str }}</div>
                </div>
                <!--<div class="train-sing-up-btn">报名</div>-->
                </div>
                <div class="train-items-title">{{ irow.name }}</div>
                <div class="flex-between">
                <div class="train-items-time">{{ irow.startdate }}</div>
                <div class="train-items-address">
                    {{ irow.province }}·{{ irow.city }}
                </div>
                </div>
            </div> 
            </div>

 


            <div class="savebtn">
            <van-button
                style="width: 3rem"
                size="normal" native-type="button" round @click="row.step=1">上一步
            </van-button> 
            </div>

        </div>

        <LoginDialog
            :show="loginShow"
            @loginSuccess="loginSuccess"
            @loginCancel="loginCancel"
        />
    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }
    .huiyi-box-title {
    margin: 10px 10px;
    /* height: 0.45rem; */
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 0.45rem;
    margin-bottom: 0;
    }

    .huiyi-group-item-box {
    margin: 10px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    }

    .huiyi-group-item-box {
    margin: 10px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    }
    .baoming-item {
    /* background: rgba(222, 150, 40, 0.28); */
    border-radius: 34px;
    /* border: 1px solid #de9628; */
    padding: 0.1rem 0.3rem;
    display: inline-block;
    font-size: 28px;
    margin-right: 20px;
    margin-bottom: 30px;
    /* line-height: 0.51rem; */
    }
    .baoming-item-box {
    padding-left: 10px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 50px;
    }


    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .flex-between {
    display: flex;
    justify-content: space-between;
    }
    .fontFamily {
    font-family: "PingFangSC-Regular,PingFang SC";
    }

    .train-items {
    width: 48%;
    margin-bottom: 0.3rem;
    }

    .items-top1 {
    background-image: linear-gradient(to right, #01ea9b, #8dec9d);
    }
    .items-top2 {
    background-image: linear-gradient(to right, #2b7aff, #1eb2ff);
    }

    .train-items-top {
    /* width: 3.08rem; */
    height: 1.68rem;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    }
    .train-items-top-city {
    color: #fff;
    font-size: 28px;
    font-weight: 500;
    font-family: PingFangSC-Medium, PingFang SC;
    }
    .train-items-top-time {
    color: #fff;
    font-size: 15px;
    font-weight: 500;
    font-family: PingFangSC-Medium, PingFang SC;
    }
    .train-sing-up-btn {
    width: 48px;
    height: 26px;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    font-family: "PingFangSC-Medium,PingFang SC";
    border: 1px solid #fff;
    border-radius: 26px;
    text-align: center;
    line-height: 26px;
    }
    .train-items-title {
    color: #333;
    font-size: 14px;
    font-weight: 400;
    font-family: "PingFangSC-Medium,PingFang SC";
    margin: 5px 0;
    }
    .train-items-time,
    .train-items-address {
    color: #595757;
    font-size: 12px;
    font-weight: 400;
    font-family: "PingFangSC-Medium,PingFang SC";
    }
    .train-items-address {
    margin-right: 10px;
    }

 

</style>
<script>
    import Vue from 'vue'; 
    import LoginDialog from "@/components/LoginDialog.vue";
    import PicUploader from '@/components/picker/PicUploader.vue'; 

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon,Dialog, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
 

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Dialog).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFormStep1',
        components: {
            [Field.name]: Field,
            PicUploader, 
            LoginDialog,
        },
        data: function () {
            return { 
                groupIndex:0, 
                groupRow:{},
                loginShow:false,
                saveLoading:false,
                row:{
                    group_list:[ 
                    ],
                    huiyiBaomingCount:0,
                    doing:[],
                    saidoing:[],
                    check_types:[],
                    step:0,
                }
            }
        },
        filters: {},
        mounted() {
            let that = this; 
            document.title = '活动报名'; 
            this.fetch()
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: { 
            go2(item){
                if(this.row.huiyiBaomingCount==0 && (this.row.check_types.indexOf(1)>-1||this.row.check_types.indexOf(2)>-1)){ 
                        Dialog.confirm({
                        title: '温馨提示',
                        message: '系统检测到您并未报名10号开始的相关场次，为了避免重复收取您的食宿费，请您先报名10号开始的场次。',
                        confirmButtonText:'我知道了', 
                        }).then(() => {
                            // rbLink({name:'HuiyiApplyFormStep1',query:{saiqu_id:item.id}})
                        // on close 
                        }).catch(() => { 
                        });;
                        return ; 
                }else{ 
                    rbLink({name:'HuiyiApplyFormStep1',query:{saiqu_id:item.id}})
                }
            },
            fetch() {
                let that = this;
                this.$api.get(
                    "/api/huiyi/index331",
                    {},
                    (res) => {
                    console.log(res);
                    that.row = res.data; 
                    },
                    (res) => {
                    console.log("没有登录");
                    if (res.code == 401 || res.code == 402) {
                        if (window.isApp()) {
                        rbLink(
                            {
                            name: "login",
                            query: {},
                            },
                            "replace"
                        );
                        return false;
                        }
                        that.loginShow = true;
                    } else {
                        Toast(res.msg);
                    }
                    }
                );
            }, 
            loginSuccess(res) {
                console.log("-------登录成功--------", res);
                this.loginShow = false;
                this.fetch();
            },

            loginCancel() {
                console.log("-------取消登录--------");
                // this.loginShow = false;
            },
            onGroupBtn(item, index) {
                item.checked = !item.checked
                this.groupIndex = index;
                this.groupRow = item;
            },
            getBackground(item,index) {
                let back = "";
                let colors = [
                    { color: "222, 150, 40," },
                    { color: "199, 189, 189," },
                    { color: "165, 131, 230," },
                    { color: "226, 166, 182," },
                ];
                console.log(index, this.groupIndex);
                if (item.checked) {
                    back =
                    "background:#de9628;color:#fff;"+
                    ";border:1px solid rgba(" +
                    colors[index % 4].color +
                    " 1)";
                } else {
                    back =
                    "background:rgba(" +
                    colors[index % 4].color +
                    " 0.28);border:1px solid #f8f8f8";
                }
                return back;
            },
            submit(){ 
                let that = this
                let checks = this.row.group_list.filter(item =>{
                    return item.checked
                })
                if(checks.length==0){
                    Toast('请至少选择一个项目');
                    return 
                }
                let checksname = checks.map(item =>{
                    return '【'+item.name+'】'
                }).join(',')
                let types = checks.map(item =>{
                    return item.id
                })
                Dialog.confirm({
                    message: '您确认选择报名 '+checksname+' 这几项目吗？'
                }).then(() => {  
                    that.$api.post('/api/huiyi/save331', { 
                        types
                    }, (res) => {
                        Toast('保存成功');
                        this.fetch()
                    }, (res) => {
                        Toast.fail(res.msg);
                    })
                }).catch(() => {
                    // on cancel
                });
            },
            jump(){
                rbLink({
                    name:'Apply331FormStep2'
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ApplyFormStep1.vue?8add0dc0